import React from 'react';
import type { JobChainTemplateGraph } from '@/api/JobChainTemplates';
import { useTranslate } from '@/translations';

export const PreservedGraphFields = ({
  graph,
}: {
  graph: JobChainTemplateGraph;
}) => {
  const { t } = useTranslate();
  const entries: Array<{ path: string; value: unknown }> = [];
  const collect = (value: object, known: string[], path: string) => {
    Object.entries(value).forEach(([key, field]) => {
      if (!known.includes(key))
        entries.push({ path: `${path}.${key}`, value: field });
    });
  };
  collect(graph, ['nodes', 'edges'], t('jobChainTemplateEditorGraph'));
  graph.nodes.forEach((node, index) =>
    collect(
      node,
      ['key', 'id', 'jobTemplateId', 'joinPolicy', 'deleted'],
      t('jobChainTemplateEditorNodeNumber', { number: index + 1 }),
    ),
  );
  graph.edges.forEach((edge, index) => {
    collect(
      edge,
      ['key', 'id', 'fromKey', 'toKey', 'groupId', 'conditions'],
      t('jobChainTemplateEditorEdgeNumber', { number: index + 1 }),
    );
    edge.conditions.forEach((condition, conditionIndex) =>
      collect(
        condition,
        ['id', 'groupId', 'name', 'condition', 'value'],
        t('jobChainTemplateEditorEdgeCondition', {
          edge: index + 1,
          condition: conditionIndex + 1,
        }),
      ),
    );
  });
  if (!entries.length) return null;
  return (
    <details>
      <summary>{t('jobChainTemplateEditorPreservedFields')}</summary>
      <dl>
        {entries.map((entry) => (
          <React.Fragment key={entry.path}>
            <dt>{entry.path}</dt>
            <dd>
              {typeof entry.value === 'string'
                ? entry.value
                : JSON.stringify(entry.value)}
            </dd>
          </React.Fragment>
        ))}
      </dl>
    </details>
  );
};
